import {
  aRulePage,
  mockRulesListForSelectQueryOperationQuery,
} from '__generated__';
import { SAMPLE_RULES } from 'mocks/shared/rules';

export const handlers = [
  mockRulesListForSelectQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        rules: aRulePage({
          objects: SAMPLE_RULES,
        }),
      })
    );
  }),
];
